/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable tss-unused-classes/unused-classes */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { DrawerFitted } from '@AMIEWEB/Common';
import { NavigationProfileCycle } from '@AMIEWEB/Common/NavigationProfileCycle';
import { IFacilityDetails } from '@AMIEWEB/Facility/FacilityStore/Facility.model';
import { SearchDrawerContent } from '@AMIEWEB/GlobalSearch/SearchResultsPage';
import { getMultiSelectOptions } from '@AMIEWEB/GlobalSearch/helper';
import { navigationProfilesAction } from '@AMIEWEB/GlobalSearch/store/NavigationProfiles.redux';
import {
  selectNavigationProfilesFlag,
  selectNavigationProfilesItems,
  selectNavigationRowId,
} from '@AMIEWEB/GlobalSearch/store/NavigationProfiles.selectors';
import OrderDetailHeader from '@AMIEWEB/NewOrder/CreateOrder/Common/OrderDetailHeader';
import { OrderSummary } from '@AMIEWEB/NewOrder/OrderDetails/OrderSummary';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDecision } from '@optimizely/react-sdk';
import { Alert, Box, Grid, Skeleton } from '@mui/material';
import { trackException } from 'app-insights/appInsightsTracking';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { createOrderContacts } from 'app/components/Candidate/CandidateProfile/CandidateHeader/contactTabHelper';
import { BreadcrumbNavigation } from 'app/components/Common/BreadcrumbNavigation/BreadcrumbNavigation';
import { CommonNoDataPage } from 'app/components/Common/NoDataPage/CommonNoDataPage';
import {
  IOrderDetailsView,
  ITypeAheadOptions,
  orderDataActions,
  orderDataReducer,
  orderDataSliceKey,
  OrderSkillsetUpdateError,
} from 'app/components/Order/Store/Order.redux';
import {
  selectIsMarginOrderBaseDetailsValid,
  selectOrderDetailsUIView,
  selectOrderPayPackagesGridIsDirty,
  selectOrderRegions,
  selectPreferenceChanged,
  selectTabValue,
} from 'app/components/Order/Store/Order.selectors';
import { setEntityStickChoosen } from 'app/components/Tasks/TaskSidebar/Transformers';
import { taskDetailsActions, taskDetailsReducer, taskDetailsSliceKey } from 'app/components/Tasks/store/Tasks.redux';
import { taskDetailsSaga } from 'app/components/Tasks/store/Tasks.saga';
import { selectTaskStickChosen } from 'app/components/Tasks/store/Tasks.selectors';
import { ff_order_ui_rate_card } from 'app/constants/FeatureFlags/Tasks/Notifications/Keys';
import { ExceptionType } from 'app/enums/Common';
import { convertToFormat } from 'app/helpers/dateHelper';
import { getExtensionDuration } from 'app/helpers/getExtensionDuration';
import { DetailsPage } from 'app/layout/pages/DetailsPage';
import { candidatePreferenceMatchData } from 'app/models/Candidate/CandidatePreferenceMatch';
import { UnitResponse } from 'app/models/Facility/Unit';
import { RouteParams } from 'app/models/Orders/Order';
import {
  IAtAGlance,
  IOrderDetails,
  IOrderReportDetails,
  OrderHeaderSection,
  OrderResponse,
  QuickGlance,
  updateLastVerifiedData,
} from 'app/models/Orders/OrderDetails';
import { ITaskStickChosen, TaskEntity } from 'app/models/Tasks/Tasks';
import { NewUnit, OrderPriorityType, SkillSetType } from 'app/models/Unit/CreateUnit';
import { AMNDivision } from 'app/models/enums/AMNDivisionType';
import { getUnitDetailsForFacility } from 'app/services/FacilityServices/FacilityServices';
import {
  getOrderDetailsWithPlacements,
  getOrderReportDetailsById,
  updateLastVerified,
  updateOrder,
} from 'app/services/OrderServices/OrderServices';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { httpSuccess } from 'app/services/serviceHelpers';
import { selectNavigationData } from '../../Common/BreadcrumbNavigation/BreadcrumbNavigation.selector';
import { CreatePlacementWrapper } from '../../Placement/CreatePlacement';
import moment from 'moment';
import { userDevicePreferenceActions, userDevicePreferenceKey } from 'oidc/UserDevicePreference/userPreference.redux';
import { userDevicePreferenceSaga } from 'oidc/UserDevicePreference/userPreference.saga';
import { selectUser } from 'oidc/user.selectors';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import uuid from 'react-uuid';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { createOrderOcbrSaga } from 'store/redux-store/create-order-ocbr/saga';
import { selectCreateOrderOcbr } from 'store/redux-store/create-order-ocbr/selector';
import {
  createOrderOcbrActions,
  createOrderOcbrReducer,
  createOrderOcbrSliceKey,
} from 'store/redux-store/create-order-ocbr/slice';
import { selectSearchResults } from 'store/redux-store/global-search/selectors';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { makeStyles } from 'tss-react/mui';
import {
  SessionKey,
  StorageType,
  appendSessionValue,
  getSessionValue,
} from 'utils/customHooks/sessionStorage/sessionHelpers';
import _, { parseInt } from 'lodash';
import {
  GetDisciplineOptions,
  GetDivisionDisciplinesOptions,
  GetSpecialtyOptions,
  GetSubSpecialtyOptions,
} from '../OrderCreationForm/OrderDetails/FormatData';
import { RateCard } from '../OrderCreationForm/RateCard/RateCard';
import { createUpdateOrderSkillsetPayload } from '../OrderCreationForm/RateCard/helper';
import {
  getAllRateElements,
  getFacilityRateElementDocumentsDataToSave,
  getOffContractDataToSave,
} from '../OrderCreationForm/RateCard/saveHelper';
import { orderDataSaga } from '../Store/Order.saga';
import { OrderCandidateMatchWrapper } from './OrderCandidateMatch/OrderCandidateMatchWrapper';
import { OrderDetailsButtonWrapper } from './OrderDetailsButtonWrapper';
import { OrderDetailReportWrapper } from './OrderDetailsReport/OrderDetailReportWrapper';
import { OrderHeader, UserRoleSearchResultItem } from './OrderHeader/OrderHeader';
import { OrderHeaderWrapper } from './OrderHeaderWrapper';
import { OrderPlacementsWrapper } from './OrderPlacements/OrderPlacementsWrapper';
import { OrderPreferencesWrapper } from './OrderPreferences/OrderPreferencesWrapper';
import {
  orderPreferenceActions,
  orderPreferenceReducer,
  orderPreferenceSliceKey,
} from './OrderPreferences/store/OrderPreference.redux';
import { orderPreferenceSaga } from './OrderPreferences/store/OrderPreference.saga';
import { OrderQuickGlance } from './OrderQuickGlance/OrderQuickGlance';
import { OrderSidePanel } from './SidePanel/OrderSidePanel';
import {
  customAddWeek,
  shouldClearEndDateForPlacementLength,
  editOrderDetails,
  formatAddress,
  formatDate,
  getDefaultValueIfNull,
  getDistinctCandidate,
  getEmptyFacility,
  getName,
  getOrderReasonId,
  getValue,
  toFixed,
} from './helper';
import { GenericTabs } from '@AMIEWEB/Common/Tabs/GenericTabs';
import { OrderBonusWrapper } from './OrderBonus/OrderBonusWrapper';
import { isPostionChangedToZero } from '@AMIEWEB/NewOrder/Store/helper';
import { WrapperComponent } from '@AMIEWEB/NewOrder/CreateOrder/Common/WrapperComponent';
import { WrapperForExperience } from '@AMIEWEB/NewOrder/CreateOrder/Common/WrapperForExperience';
import { WrapperComponentWithSubSections } from '@AMIEWEB/NewOrder/CreateOrder/Common/WrapperComponentWithSubSections';
import {
  formattedSkillSet,
  getAdditionalQualificationString,
  getQualificationStringExperience,
} from '@AMIEWEB/NewOrder/CreateOrder/helper';
import { Concatenate } from 'utils/string/string';
import { orderCreationNewReducer, orderCreationNewSliceKey } from '@AMIEWEB/NewOrder/Store/OrderCreation.redux';
import { orderCreationNewSaga } from '@AMIEWEB/NewOrder/Store/OrderCreation.saga';
import { IOrderQualificationFreeText } from '@AMIEWEB/NewOrder/constants';
import { orderCreationNewActions } from '@AMIEWEB/NewOrder/Store/OrderCreation.actions';
import { IRecentHistoryOrder } from 'app/models/Global/RecentHistoryModels';
import { PreferenceCosmosKeys } from 'oidc/UserDevicePreference/utils';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import { isEditLoader } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { OrderChangeHistoryWrapper } from './OrderChangeHistory/OrderChangeHistoryWrapper';
import { ff_order_global_margintool, ff_order_global_margintool_ui } from 'app/constants/FeatureFlags/MarginTool/Keys';
import { PayPackagesWrapper } from './PayPackages/PayPackagesWrapper';

const useStyles: any = makeStyles()(theme => ({
  sidePanelLink: {
    color: '#006FB9',
    fontSize: '14px',
    fontWeight: 400,
    cursor: 'pointer',
  },
  moreWrapper: {
    width: 20,
    height: 20,
    border: '1px solid #006FB9 !important',
    color: '#006FB9',
    display: 'inline-block',
    borderRadius: '50%',
    marginRight: 7,
  },
  moreIcon: {
    fontSize: 20,
    paddingRight: 2,
    paddingBottom: 5,
  },
  statusButton: {
    fontSize: 12,
  },
  verifyButton: {
    fontSize: 12,
    marginLeft: '10px',
  },
  customAlert: {
    width: '100%',
    zIndex: 99,
    position: 'fixed',
    top: '40px',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    '& .MuiAlert-icon': {
      fontSize: 24,
      color: '#694D28',
    },
    alignItems: 'center',
    height: '52px',
  },
  alertMessage: {
    padding: '13px 0',
  },
  alertColor: {
    backgroundColor: '#E8F4FD',
  },
  alertIcon: {
    padding: '9px 0',
  },
}));

export const OrderDetailsContent: React.FC<RouteParams> = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const { promiseInProgress } = usePromiseTracker();
  const { promiseInProgress: isUpdating } = usePromiseTracker({ area: 'update-order', delay: 0 });
  const [inProgress, setInProgress] = useState(false);
  const navigationData = useSelector(selectNavigationData);
  const userPreference = useSelector(selectUserPreference);
  const userData = useSelector(selectUser);
  useInjectSaga({ key: taskDetailsSliceKey, saga: taskDetailsSaga });
  useInjectReducer({ key: taskDetailsSliceKey, reducer: taskDetailsReducer });
  useInjectReducer({ key: orderPreferenceSliceKey, reducer: orderPreferenceReducer });
  useInjectReducer({ key: createOrderOcbrSliceKey, reducer: createOrderOcbrReducer });
  useInjectSaga({ key: createOrderOcbrSliceKey, saga: createOrderOcbrSaga });
  useInjectReducer({ key: orderCreationNewSliceKey, reducer: orderCreationNewReducer });
  useInjectSaga({ key: orderCreationNewSliceKey, saga: orderCreationNewSaga });
  useInjectSaga({ key: orderPreferenceSliceKey, saga: orderPreferenceSaga });

  useInjectReducer({ key: orderDataSliceKey, reducer: orderDataReducer });

  useInjectSaga({ key: orderDataSliceKey, saga: orderDataSaga });
  useInjectSaga({ key: userDevicePreferenceKey, saga: userDevicePreferenceSaga });

  const [modalOpen] = useState<boolean>(false);

  const [blockNavigation] = useState<boolean>(false);
  const [openClearChangesConfirmation, setOpenClearChangesConfirmation] = useState(false);
  const [lastVerifiedUpdateStatus, setLastVerifiedUpdateStatus] = useState<boolean>(false);
  const [matchedCandidates] = useState<candidatePreferenceMatchData[]>([]);
  const [activateView, setActivateView] = useState<number>(0);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [openCreatePlacementForm, setOpenCreatePlacementForm] = useState<boolean>(false);
  const [openCreatePlacementFormX, setOpenCreatePlacementFormX] = useState<boolean>(false);
  const [candidateIdR, setCandidateIdR] = useState<number>(0);
  const [brandIdR, setBrandIdR] = useState<number>(0);
  const [orderIdR, setOrderIdR] = useState<number>(0);
  const [stickChoosen, setStickChoosen] = useState<ITaskStickChosen>({ entity: TaskEntity.ORDERS, stick: null });
  const selectOrderUiDetails = useSelector(selectOrderDetailsUIView);
  const [showMandetryCss, setShowMandetryCss] = React.useState<boolean>(false);
  const userInfo = {
    userId: userData.userInfo?.employeeId,
    userName: userData.userInfo?.firstName + ' ' + userData.userInfo?.lastName,
  };
  const [rateCardFlag] = useDecision(ff_order_ui_rate_card);
  const [featureFlagOrderMarginTool] = useDecision(ff_order_global_margintool);
  const [featureFlagOrderMarginToolUI] = useDecision(ff_order_global_margintool_ui);
  const taskStickChosen = useSelector(selectTaskStickChosen);

  const [upDisabled, setUpDisabled] = useState<boolean>(false);
  const [downDisabled, setDownDisabled] = useState<boolean>(false);

  const history = useNavigate();
  const location = useLocation();
  const navigationProfiles = useSelector(selectNavigationProfilesItems);
  const navigationFlag = useSelector(selectNavigationProfilesFlag);
  const navigationRowId = useSelector(selectNavigationRowId);
  const loader = useSelector(isEditLoader);
  const params = useParams() as unknown;
  const [currentIndex, setCurrentIndex] = useState<number | undefined>(undefined);
  const [preLoadedBrands, setPreLoadedBrand] = React.useState<any[]>([]);
  const [offContractId] = useState(uuid());

  const editRateData = useSelector(selectCreateOrderOcbr);
  const user = useSelector(selectUser);
  const regions = useSelector(selectOrderRegions);
  const preferenceChanged = useSelector(selectPreferenceChanged);

  const isMarginOrderBaseDetailsValid = useSelector(selectIsMarginOrderBaseDetailsValid);
  // NOTE: use an inline selector here to avoid runtime issues if the named selector import
  // is ever undefined due to module loading/HMR edge cases.
  const hasPlacementPayPackageScenarios = useSelector((state: any) => {
    const loaded = state?.orderData?.placementPayPackagesLoaded === true;
    const rows = state?.orderData?.placementPayPackagesSource;
    return loaded && Array.isArray(rows) && rows.length > 0;
  });

  const [searchParams] = useSearchParams();
  const tabValueFallback = Number(searchParams.get('tab') || 0);
  const tabValue = useSelector(selectTabValue) || tabValueFallback;
  const orderPayPackagesGridIsDirty = useSelector(selectOrderPayPackagesGridIsDirty);

  const fetchBrandFilterSpecs = async () => {
    const [brandLookups] = await Promise.all([getSearchFilterOptions('brands')]);
    const brandOpts = getMultiSelectOptions(brandLookups || []);
    setPreLoadedBrand(brandOpts);
  };

  React.useEffect(() => {
    let currVal;
    let navigationIndex = navigationProfiles.findIndex(s => s.id === navigationRowId);
    currVal = navigationIndex;

    setDownDisabled(navigationIndex === navigationProfiles?.length - 1);
    setUpDisabled(navigationIndex === 0);

    setCurrentIndex(currVal);
    return () => {
      dispatch(navigationProfilesAction.setNavigationFlag({ navigationFromGrid: false }));
      dispatch(orderDataActions.setTabValue(0));
    };
  }, [params?.id, navigationRowId]);

  useEffect(() => {
    const recentHistoryPrefs = userPreference?.recentHistory?.value;
    let newRecentHistoryPrefs = _.cloneDeep(recentHistoryPrefs);
    let orderArray: IRecentHistoryOrder[] = recentHistoryPrefs?.order ? [...recentHistoryPrefs?.order] : [];

    const orderId = props?.id;
    const name = selectOrderUiDetails?.headerDetails?.facilityName;

    if (!!orderId && !!name && recentHistoryPrefs !== null) {
      const orderVal: IRecentHistoryOrder = {
        orderId: orderId,
        name: name,
      };
      const index = orderArray?.findIndex(item => item.orderId === orderId);

      if (index === -1) {
        orderArray.unshift(orderVal);
        if (orderArray?.length > 5) {
          orderArray = orderArray.slice(0, 5);
        }
      } else {
        orderArray.splice(index, 1);
        orderArray.unshift(orderVal);
        if (orderArray?.length > 5) {
          orderArray = orderArray.slice(0, 5);
        }
      }
      newRecentHistoryPrefs = { ...newRecentHistoryPrefs, order: orderArray };
      dispatch(
        userDevicePreferenceActions.saveUserRecentHistoryPreferenceAction({
          id: PreferenceCosmosKeys.recentHistory,
          value: newRecentHistoryPrefs,
        }),
      );
    }
  }, [props?.id, selectOrderUiDetails?.headerDetails?.facilityName]);

  useEffect(() => {
    fetchBrandFilterSpecs();
    trackPromise(fetchData(), '');
    if (featureFlagOrderMarginTool.enabled && featureFlagOrderMarginToolUI.enabled) {
      dispatch(orderDataActions.getWeeklyGrossPay(Number(props.id)));
    }
    if (rateCardFlag.enabled) {
      dispatch(orderDataActions.getRateElementsAction(parseInt(props.id)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  useEffect(() => {
    if (loader?.isSaveFailed && loader?.errorCode === OrderSkillsetUpdateError) {
      dispatch(
        globalActions.setBanner({
          message: loader?.errorBannerMessage,
          severity: 'error',
        }),
      );
    }
  }, [loader?.isSaveFailed]);

  const fetchData = async () => {
    try {
      setInProgress(true);
      let orderDetailsViewTemp = {} as IOrderDetailsView;
      const response: OrderResponse = await getOrderDetailsWithPlacements(props.id);
      const facilityId = response.orderDetails?.facility?.facilityId;
      const unitIdLc = response.orderDetails?.unit?.unitId;
      let unitsData: UnitResponse[] = [];
      let unitsFilterd: NewUnit = null;
      if (facilityId && unitIdLc) {
        unitsFilterd = await getUnitDetailsForFacility(facilityId, unitIdLc);
        dispatch(orderPreferenceActions.getClientContacts({ facilityId: facilityId, unitId: unitIdLc }));
      }
      const orderDetails: IOrderDetails = response.orderDetails;
      const orderReportDetails: IOrderReportDetails = await getOrderReportDetailsById(props.id);

      dispatch(
        createOrderOcbrActions.setOcbrEffectiveDate({
          startDate: orderDetails?.orderRateEffectiveStartDate,
          endDate: orderDetails?.orderRateEffectiveEndDate,
        }),
      );

      //1 credit hold || 3 cred pending
      if (response?.orderDetails?.facility?.creditStatusId === 1) {
        orderDetailsViewTemp.creditStatus = true;
        orderDetailsViewTemp.pendingStatus = false;
      } else if (response?.orderDetails?.facility?.creditStatusId === 3) {
        orderDetailsViewTemp.creditStatus = false;
        orderDetailsViewTemp.pendingStatus = true;
      } else {
        orderDetailsViewTemp.creditStatus = false;
        orderDetailsViewTemp.pendingStatus = false;
      }

      orderDetailsViewTemp.orderResponse = response;
      orderDetailsViewTemp.orderDetails = orderDetails;
      orderDetailsViewTemp.orderDetailsOrginal = _.cloneDeep(orderDetails);
      orderDetailsViewTemp.facilityId = facilityId;
      orderDetailsViewTemp = generateFlattenDetails(orderDetailsViewTemp);
      orderDetailsViewTemp.selectedNewUnitId = unitIdLc;
      orderDetailsViewTemp.currentStep = 'ViewOrderDetails';
      orderDetailsViewTemp.isEditStarted = false;
      orderDetailsViewTemp.editMode = 'inline';
      orderDetailsViewTemp.unitsData = unitsData;
      if (unitsFilterd) {
        orderDetailsViewTemp.selectedNewUnit = unitsFilterd;
      }
      let requiredQualificationDetails = orderDetailsViewTemp.orderDetails?.submissionRequirements;
      orderDetailsViewTemp = {
        ...orderDetailsViewTemp,
        orderDetails: {
          ...orderDetailsViewTemp.orderDetails,
          requiredQualifications: requiredQualificationDetails,
        },
      };
      orderDetailsViewTemp.orderReportDetails = orderReportDetails;
      dispatch(orderDataActions.setOrderDetailsView(orderDetailsViewTemp));
      dispatch(orderDataActions.setNewUnit(orderDetailsViewTemp.selectedNewUnit));
      dispatch(orderDataActions.setCurrentUnitId(orderDetailsViewTemp.selectedNewUnitId));
      if (featureFlagOrderMarginTool.enabled && featureFlagOrderMarginToolUI.enabled) {
        dispatch(
          orderDataActions.getOrderTargetMargins({
            payload: {
              orderId: Number(props?.id),
              userId: user?.userInfo?.employeeId,
            },
          }),
        );
      }
      loadTypeAheadOptions();
      appendSessionValue(SessionKey.recentOrders, {
        orderId: response.orderDetails.orderId,
        facilityId: response.orderDetails?.facility?.facilityId,
        facility: response.orderDetails?.facility?.name,
      });
    } catch (error) {
      dispatch(
        globalActions.setSnackBar({
          message: t('candidate.credentials.networkError'),
          severity: 'error',
        }),
      );

      trackException({
        exception: error,
        properties: {
          name: ExceptionType.CommonUIError,
          functionName: 'fetchData',
          area: 'src/app/components/Order/OrderDetails/OrderDetailsContent.tsx',
        },
      });
    }
    setInProgress(false);
  };

  const generateRequiredQualificationText = (orderDetails: IOrderDetails) => {
    const qualificationTextDetails: IOrderQualificationFreeText = {
      orderId: orderDetails?.orderId,
      additionalRequiredQualifications: orderDetails?.additionalRequiredQualifications ?? '',
      jobDescription: orderDetails?.jobDescription ?? '',
      internalNotes: orderDetails?.internalNotes ?? '',
      preferredQualifications: orderDetails?.preferredQualifications ?? '',
      requiredQualifications: orderDetails?.requiredQualifications ?? '',
    };

    const formattedSkillSetGroup = formattedSkillSet(orderDetails?.skillSetGroup?.groups);
    let [requiredQualificationText, preferredQualificationText] = getQualificationStringExperience(
      qualificationTextDetails,
      formattedSkillSetGroup,
      null,
      orderDetails?.additionalInformation,
    );

    requiredQualificationText = Concatenate(
      [
        requiredQualificationText,
        getAdditionalQualificationString(
          orderDetails?.ssnRequired,
          orderDetails?.dobRequired,
          orderDetails?.orderWorkHistory,
          orderDetails?.reference,
        ),
        orderDetails?.additionalRequiredQualifications,
      ],
      '\n',
    );
    const qualificationFreeText: IOrderQualificationFreeText = {
      ...qualificationTextDetails,
      requiredQualifications: requiredQualificationText,
      isUpdatedFeeText: true,
    };
    dispatch(orderCreationNewActions.onUpdateQualificationFreeText(qualificationFreeText));
    return requiredQualificationText;
  };

  const generateFlattenDetails = (orderDetailsViewTemp: IOrderDetailsView) => {
    orderDetailsViewTemp.facilityDetails = getFacilityDetailsFromOrderDetails(orderDetailsViewTemp.orderDetails);
    orderDetailsViewTemp.headerDetails = flattenHeaderData(orderDetailsViewTemp.orderDetails);
    orderDetailsViewTemp.quickGlanceDetails = flattenQuickGlanceData(
      orderDetailsViewTemp.orderDetails,
      orderDetailsViewTemp.orderResponse.candidatePreferenceMatch,
    );
    orderDetailsViewTemp.atAGlance = flattenDetails(orderDetailsViewTemp.orderDetails);
    return orderDetailsViewTemp;
  };

  const getFacilityDetailsFromOrderDetails = (response: IOrderDetails) => {
    const emptyFacility = getEmptyFacility();
    const newFacilityData = {
      ...emptyFacility,
      facilityResponse: {
        ...emptyFacility.facilityResponse,
        ...response?.facility,
        facilityName: response?.facility?.name ? response.facility.name : '-',
        healthSystemName: response.unit.name,
        bestBets: response.unit?.bestBets,
        bestBetsId: response?.facility?.facilityBestBetsId,
        employeeContacts: {
          recruiter: {
            userId: response.contacts.recruiter?.userId,
            firstName: response.contacts.recruiter?.firstName,
            lastName: response.contacts.recruiter?.lastName,
          },
          accountManager: {
            userId: response.contacts.accountManager.userId,
            firstName: response.contacts.accountManager.firstName,
            lastName: response.contacts.accountManager.lastName,
          },
          regionalDirector: {
            userId: response.contacts.regionalDirector.userId,
            firstName: response.contacts.regionalDirector.firstName,
            lastName: response.contacts.regionalDirector.lastName,
          },
          credentialingAnalyst: {
            userId: response.contacts.credentialingAnalyst?.userId,
            firstName: response.contacts.credentialingAnalyst?.firstName,
            lastName: response.contacts.credentialingAnalyst?.lastName,
          },
          clinicalManager: {
            userId: response.contacts.clinicalManager?.userId,
            firstName: response.contacts.clinicalManager?.firstName,
            lastName: response.contacts.clinicalManager?.lastName,
          },
        },
        location: response.location,
        facilityStatus: response.status,
        division: response.division,
      },
    } as IFacilityDetails;
    return newFacilityData;
  };

  const getUnitDetailsFromOrderDetails = (unit: NewUnit, orderDetails: IOrderDetails) => {
    const skillSetTemp: SkillSetType[] = [];
    orderDetails.skillsets?.map(item => {
      skillSetTemp.push({
        discipline: item.discipline,
        disciplineId: item.disciplineId,
        isRequired: item.isRequired,
        specialty: item.specialty,
        specialtyId: item.specialtyId,
        isPrimary: item.isPrimary,
        subSpecialty: item.subSpecialty,
        subSpecialtyId: item.subSpecialtyId,
        yearsOfExperience: item.yearsOfExperience,
      } as SkillSetType);
    });
    unit.experience = {
      isNewGrad: orderDetails.newGrad,
      skillSets: skillSetTemp,
    };
    unit.externalJobDescription = orderDetails.jobDescription ?? '';
    unit.internalNotes = orderDetails.internalNotes ?? '';
    unit.reference = orderDetails.unit.reference ?? {
      isRequired: false,
      numberOfReferenceRequired: 0,
      numberOfReferenceToRFO: 0,
      withinMonths: false,
      referenceFromSupervisor: false,
    };
    unit.travelExperience = orderDetails.unit.travelExperience;
    unit.qualification = orderDetails.unit.qualification;
    const orderPriorityTypeTemp: OrderPriorityType[] = [];
    orderDetails.orderPriorities?.map(item => {
      orderPriorityTypeTemp.push({
        id: item.orderPriorityTypeId,
        description: item.description,
      });
    });
    unit.orderPriorities = orderPriorityTypeTemp;
    unit.float = orderDetails.unit.float;
    unit.flexibleSchedule = orderDetails.unit.flexibleSchedule;
    unit.nonStandardRequirement = orderDetails.unit.nonStandardRequirement;
    return unit;
  };

  const flattenHeaderData = (response: IOrderDetails) => {
    return {
      orderID: response.orderId !== '' ? response.orderId : 'XXXXXX',
      facilityName: response?.facility?.name ? response.facility.name : '-',
      facilityId: response?.facility?.facilityId,
      unit: response.unit.name,
      location: response.location
        ? formatAddress(response.location)
        : {
            addressLine1: null,
            addressLine2: 'N/A',
            phoneNumber: null,
          },
      skillSet: response.skillsets,
      lastVerified: response.dateVerified ? response.dateVerified : 'N/A',
      verifiedBy: response.contacts?.verifiedBy ? getName(response.contacts.verifiedBy) : 'N/A',
      accountManager: response.contacts ? getName(response.contacts.accountManager) : 'N/A',
      regionalDirector: response.contacts ? getName(response.contacts.regionalDirector) : 'N/A',
      type: response.orderType,
      division: response.division,
      brandName: response.brandinfo ? response.brandinfo[0].brandName : [],
      contacts: createOrderContacts(response?.contacts),
      status: response.status || 'N/A',
    } as OrderHeaderSection;
  };

  const flattenDetails = (response: IOrderDetails) => {
    return {
      dateVerified: response.dateVerified ? formatDate(response.dateVerified, 'dateAnd12HourTimeWithSecs') : '-',
      verifiedBy: response.contacts.verifiedBy ? getName(response.contacts.verifiedBy) : '-',
      positionsAvailable: response.positionsAvailable,
      startDate: response.startDate ? formatDate(response.startDate, 'dateAnd12HourTimeWithSecs') : '-',
      endDate: response.endDate ? formatDate(response.endDate, 'dateAnd12HourTimeWithSecs') : '-',
      declineFiles: response.declineFiles,
      orderDecrementReasonID: response.orderDecrementReasonID,
      placementLength: response.numOfWeeks + '',
      flexibleDates: response.flexibleDates,
      asap: response.asap,
      dateCreated: response.dateCreated ? formatDate(response.dateCreated) : '-',
      maxFilesSent: response.maxFilesSent,
      reasonForMaxFilesSent: getDefaultValueIfNull(response.reasonForMaxFilesSent),
      maxFilesSentdate: response.lastUpdatedMaxFilesSent ? formatDate(response.lastUpdatedMaxFilesSent) : '-',
      orderScore: response.orderScore ? response.orderScore + '' : '-',
      businessRelationship: response?.facility?.businessRelationship ?? '-',
      region: response.location ? response.location.region : '-',
      payCycle: getDefaultValueIfNull(response.payCycle),
      fees: response.fees + '%',
      radiusRules: response.radiusRules,
      hideFacilityDescription: response.hideFacilityDescription,
      suppressExternalPosting: response.suppressExternalPosting,
      clinicalFellowship: response.clinicalFellowship,
      expectedHours: getDefaultValueIfNull(response.expectedHours),
      guaranteedHours: getDefaultValueIfNull(response.guaranteedHours),
      orderReason: response.orderReasonId,
      nurseToPatientRatio: response.unit.nurseRatio ?? '-',
      unitSize: response.unit.unitSize ?? '-',
      costCenter: response.unit.costCenter ?? '-',
    } as IAtAGlance;
  };

  const getWeeklyGrossPay = (response: IOrderDetails) => {
    if (featureFlagOrderMarginTool.enabled && featureFlagOrderMarginToolUI.enabled) {
      return `${response?.minimumWeeklyGrossPay ? '$' + response?.minimumWeeklyGrossPay?.toLocaleString() : 'N/A'} - ${
        response?.maximumWeeklyGrossPay ? '$' + response?.maximumWeeklyGrossPay?.toLocaleString() : 'N/A'
      }`;
    }
    return response.weeklyGrossPay === null
      ? 'N/A'
      : response.weeklyGrossPay === 0
      ? '0'
      : '$' + response.weeklyGrossPay;
  };

  const flattenQuickGlanceData = (response: IOrderDetails, jobMatchres?: any) => {
    return {
      orderId: response.orderId,
      positionsAvailable: response.positionsAvailable ? response.positionsAvailable : '0',
      startDate: response.startDate ? convertToFormat(response.startDate || null, 'MM/DD/yyyy') : 'N/A',
      placementLength: response.numOfWeeks ? response.numOfWeeks + ' Weeks' : 'N/A',
      maxFilesSent: getValue(response.maxFilesSent),
      guaranteedWorkWeek: getValue(response.gww),
      activeBonus: getValue(response.activeBonus),
      weeklyGrossPay: getWeeklyGrossPay(response),
      billRate: response.orderBillRate ? '$' + toFixed(response.orderBillRate, 2) : 'N/A',
      jobMatches: jobMatchres ? getDistinctCandidate(jobMatchres) : '0',
      suppressExternalPosting: response.suppressExternalPosting,
    } as QuickGlance;
  };

  const handleOrderPropertyUpdate = (property: string, value: any) => {
    if (selectOrderUiDetails) {
      let orderDetailsOrginalTemp = _.cloneDeep(selectOrderUiDetails);
      let orderDetails = orderDetailsOrginalTemp.orderDetails;
      if (property === 'positionsAvailable') {
        if (isNaN(value)) {
          orderDetails.positionsAvailable = 0;
          orderDetails.declineFiles = false; //KeepFiles field selected in UI
        } else if (value === 0) {
          orderDetails.positionsAvailable = value;
          orderDetails.declineFiles = false; //KeepFiles field selected in UI
        } else {
          orderDetails.positionsAvailable = value;
        }
      } else if (property === 'accountManager') {
        const selectedUser = value as UserRoleSearchResultItem;
        if (selectedUser && selectedUser.name) {
          selectedUser.value = Number(selectedUser.value + '');
          const [firstName, lastName] = selectedUser.name.split(' ');
          orderDetails.contacts.accountManager.userId = selectedUser.value;
          orderDetails.contacts.accountManager.firstName = firstName;
          orderDetails.contacts.accountManager.lastName = lastName;
        }
      } else if (property === 'regionalDirector') {
        const selectedUser = value as UserRoleSearchResultItem;
        if (selectedUser && selectedUser.name) {
          selectedUser.value = Number(selectedUser.value + '');
          const [firstName, lastName] = selectedUser.name.split(' ');
          orderDetails.contacts.regionalDirector.userId = selectedUser.value;
          orderDetails.contacts.regionalDirector.firstName = firstName;
          orderDetails.contacts.regionalDirector.lastName = lastName;
        }
      } else if (property === 'placementLength') {
        if (shouldClearEndDateForPlacementLength(value)) {
          orderDetails.numOfWeeks = 0;
          orderDetails.endDate = null;
        } else if (orderDetails.startDate) {
          orderDetails.numOfWeeks = value;
          orderDetails.endDate = customAddWeek(orderDetails.startDate, value);
        } else {
          orderDetails.numOfWeeks = value;
        }
      } else if (property === 'startDate' && value !== 'Invalid Date' && value !== null) {
        orderDetails.startDate = value;
        orderDetails.numOfWeeks =
          getExtensionDuration(value, new Date(orderDetails.endDate)) ?? orderDetails.numOfWeeks;
      } else if (property === 'endDate') {
        orderDetails.endDate = value;
        orderDetails.numOfWeeks =
          getExtensionDuration(moment(orderDetails.startDate), value) ?? orderDetails.numOfWeeks;
      } else if (property === 'orderReason') {
        orderDetails.orderReasonId = getOrderReasonId(value);
      } else if (property === 'region') {
        const regionUpdated = regions.filter(item => item.Description === value);
        orderDetails.location.region = value;
        orderDetails.location.regionId = regionUpdated[0].ID;
      } else {
        orderDetails = { ...orderDetailsOrginalTemp.orderDetails, [property]: value };
      }

      orderDetailsOrginalTemp.orderDetails = orderDetails;
      orderDetailsOrginalTemp = generateFlattenDetails(orderDetailsOrginalTemp);
      orderDetailsOrginalTemp.isEditStarted = !_.isEqual(
        orderDetailsOrginalTemp.orderDetails,
        orderDetailsOrginalTemp.orderDetailsOrginal,
      );
      dispatch(orderDataActions.setOrderDetailsView(orderDetailsOrginalTemp));
    }
  };

  const MoreSideGlance = () => {
    return (
      <>
        <div
          data-glance
          className={classes.sidePanelLink}
          role="link"
          tabIndex={0}
          onClick={() => {
            setDrawerOpen(true);
          }}
          onKeyDown={() => {}}
        >
          <Box className={classes.moreWrapper} style={{ border: '1px solid #006FB9' }}>
            <MoreHorizIcon classes={{ root: classes.moreIcon }} />
          </Box>
          <span>{t('order.orderDetails.tabs.sidePanel.buttonTitle')}</span>
        </div>
      </>
    );
  };

  const handleChange = (value: number) => {
    if (activateView !== value) setActivateView(value);
  };

  const handleEditOrder = () => {
    if (selectOrderUiDetails) {
      history(`/order/${props.id}/edit`);
    }
  };

  const handleLastVerified = async () => {
    const verifiedDateTime = convertToFormat(new Date(), '');
    const lastVerifiedData: updateLastVerifiedData = {
      orderId: parseInt(props.id),
      DateVerified: verifiedDateTime ? verifiedDateTime : '',
      VerifiedByUserId: userInfo.userId ? userInfo.userId : 0,
    };
    const response = await updateLastVerified(lastVerifiedData);
    if (response) {
      setLastVerifiedUpdateStatus(false);
      dispatch(
        globalActions.setSnackBar({
          message: t(`The order ${props.id} is verified successfully`),
          severity: 'success',
        }),
      );
    } else {
      dispatch(
        globalActions.setSnackBar({
          message: t(`The order ${props.id} is verified failed`),
          severity: 'error',
        }),
      );
    }
    setLastVerifiedUpdateStatus(true);
  };

  const handleClearChanges = () => {
    setOpenClearChangesConfirmation(true);
  };

  const enableEditHSG = () => {
    return selectOrderUiDetails?.orderDetails?.division !== AMNDivision.HSG ? true : false;
  };

  const loadTypeAheadOptions = async () => {
    const disciplines = await GetDisciplineOptions();
    const specialties = await GetSpecialtyOptions();
    const subSpeciatlies = await GetSubSpecialtyOptions();
    const divisionDisciplinesOptions = await GetDivisionDisciplinesOptions();

    dispatch(
      createOrderOcbrActions.setMiscellaneousData([
        { key: 'disciplineOpts', data: disciplines },
        { key: 'specialtyOpts', data: specialties },
        { key: 'subSpecialtyOpts', data: subSpeciatlies },
        { key: 'divisionDisciplineOpts', data: divisionDisciplinesOptions },
      ]),
    );

    dispatch(
      orderDataActions.setTypeAheadOptions({
        disciplines: disciplines || [],
        specialties: specialties || [],
        subSpecialties: subSpeciatlies || [],
        divisionDisciplines: divisionDisciplinesOptions || [],
      } as ITypeAheadOptions),
    );
  };

  const handleSaveOrder = async () => {
    try {
      if (selectOrderUiDetails) {
        // Check effective dates validation on edit rate card page
        if (
          selectOrderUiDetails.currentStep === 'editRateCard' &&
          (!editRateData.ocbrDetails.effectiveDates.startDate || !editRateData.ocbrDetails.effectiveDates.endDate)
        ) {
          return;
        }

        if (selectOrderUiDetails.orderDetails.skillsets && selectOrderUiDetails.orderDetails.skillsets.length > 0) {
          setInProgress(true);
          const edittedOrder = editOrderDetails(
            selectOrderUiDetails.orderDetails,
            userData.userInfo?.employeeId ?? 0,
            false,
            userData,
          );
          const selectOrderUiDetailsTemp = _.cloneDeep(selectOrderUiDetails);
          const skillSetTemp: SkillSetType[] = [];
          selectOrderUiDetailsTemp.orderDetails.skillsets?.map(item => {
            skillSetTemp.push({
              discipline: item.discipline,
              disciplineId: item.disciplineId,
              isRequired: item.isRequired,
              specialty: item.specialty,
              specialtyId: item.specialtyId,
              isPrimary: item.isPrimary,
              subSpecialty: item.subSpecialty,
              subSpecialtyId: item.subSpecialtyId,
              yearsOfExperience: item.yearsOfExperience,
            } as SkillSetType);
          });
          const unitData = _.cloneDeep(edittedOrder.unit);
          unitData.experience = {
            isNewGrad: selectOrderUiDetailsTemp.orderDetails.newGrad ?? false,
            skillSets: skillSetTemp,
          };

          if (
            selectOrderUiDetailsTemp.orderDetails.newGrad === undefined ||
            selectOrderUiDetailsTemp.orderDetails.newGrad == null
          ) {
            selectOrderUiDetailsTemp.orderDetails.newGrad = false;
          }

          edittedOrder.skillsets = selectOrderUiDetailsTemp.orderDetails.skillsets;
          edittedOrder.unit = unitData;
          edittedOrder.orderPriorities = selectOrderUiDetailsTemp.orderDetails.orderPriorities;
          edittedOrder.NumOfWeeks = edittedOrder.placementLength;
          if (edittedOrder.orderDecrementReasonID) {
            edittedOrder.orderDecrementReasonID = Number(edittedOrder.orderDecrementReasonID);
          }

          if (edittedOrder.newGrad === undefined || edittedOrder.newGrad == null) {
            edittedOrder.newGrad = false;
          }

          if (selectOrderUiDetails?.currentStep === 'editRateCard') {
            edittedOrder['rateElements'] = getAllRateElements({
              isFlatRate: editRateData.ocbrDetails.isFlatRate,
              ocbrBillRates: editRateData.ocbrDetails.billRates,
              ...editRateData.miscellaneous,
              offContractId,
            });
            edittedOrder['isFlatRate'] = editRateData.ocbrDetails.isFlatRate;
            edittedOrder['orderRateEffectiveStartDate'] = editRateData.ocbrDetails?.effectiveDates.startDate;
            edittedOrder['orderRateEffectiveEndDate'] = editRateData.ocbrDetails?.effectiveDates.endDate;
          }
          const originalPositions = +selectOrderUiDetails?.orderDetailsOrginal?.positionsAvailable || 0;
          const currPositions = +edittedOrder?.positionsAvailable || 0;
          const isPositionChangedToZero = isPostionChangedToZero({ originalPositions, currPositions });

          const response = await updateOrder(edittedOrder, props.id);
          if (httpSuccess(response.status)) {
            const offContractDetails = getOffContractDataToSave(
              response.data.orderId,
              editRateData.ocbrDetails.billRates,
              editRateData.ocbrDetails.isFlatRate,
              editRateData.ocbrDetails.effectiveDates?.startDate,
              editRateData.ocbrDetails.effectiveDates?.endDate,
              selectOrderUiDetails.facilityId,
              offContractId,
              user,
            );
            offContractDetails && dispatch(createOrderOcbrActions.saveOffcontractDetails(offContractDetails));
            dispatch(createOrderOcbrActions.setOrderDetailsUpdatedFlag(true));
            const facilityRateElementDetails = getFacilityRateElementDocumentsDataToSave(
              response.data.orderId,
              editRateData.ocbrDetails.billRates,
              editRateData.ocbrDetails.isFlatRate,
              offContractId,
              selectOrderUiDetails.facilityId,
              user,
            );
            facilityRateElementDetails &&
              dispatch(createOrderOcbrActions.saveFacilityOffContractRateElementDocuments(facilityRateElementDetails));
            //skilset change api and payload
            if (rateCardFlag.enabled) {
              const payload = createUpdateOrderSkillsetPayload({ facilityId: props.id, response, userInfo });
              dispatch(createOrderOcbrActions.updateOrderSkillsets(payload));
            }
            const orderDetailsOrginalTemp = _.cloneDeep(selectOrderUiDetailsTemp);
            orderDetailsOrginalTemp.currentStep = 'ViewOrderDetails';
            orderDetailsOrginalTemp.isEditStarted = false;
            dispatch(orderDataActions.setOrderDetailsView(orderDetailsOrginalTemp));
            fetchData();
            setInProgress(false);
            //* Update the notification count in header here
            if (edittedOrder?.positionsAvailable === 0 && isPositionChangedToZero) {
              dispatch(taskDetailsActions.businessInitNotifications(10000));
            }

            dispatch(
              globalActions.setSnackBar({
                message: t('order.orderDetails.network.success'),
                severity: 'success',
              }),
            );
          } else {
            setInProgress(false);
            if (response?.data?.responseCode === 60119) {
              dispatch(
                globalActions.setBanner({
                  message: response?.data?.message,
                  severity: 'error',
                }),
              );
            } else {
              dispatch(
                globalActions.setSnackBar({
                  message: t('order.orderDetails.network.failure'),
                  severity: 'error',
                }),
              );
            }
          }
        } else {
          setShowMandetryCss(true);
          setInProgress(false);
        }
      }
    } catch (error) {
      setInProgress(false);
      dispatch(
        globalActions.setSnackBar({
          message: t('order.orderDetails.network.failure'),
          severity: 'error',
        }),
      );
      trackException({
        exception: error,
        properties: {
          name: ExceptionType.CommonUIError,
          functionName: 'handleSaveOrder',
          area: 'src/app/components/Order/OrderDetails/OrderDetailsContent.tsx',
        },
      });
    }
  };

  const handleClearChangesConfirmClose = (modalState: boolean, clearValues: boolean) => {
    setOpenClearChangesConfirmation(false);
    if (clearValues) {
      fetchData();
    }
  };
  const disablePayPackageTab = () => {
    if (featureFlagOrderMarginTool.enabled && featureFlagOrderMarginToolUI.enabled) {
      //Hide Save Button if user is on PayPackage Tab
      return tabValue !== 6;
    }
    return true;
  };

  const tabs = [
    {
      label: t('order.orderDetails.tabs.summary'),
      component: <OrderSummary isNewOrderCreation={false} />,
    },
    {
      label: t('order.orderDetails.tabs.placements'),
      component: <OrderPlacementsWrapper />,
    },
    {
      label: t('order.orderDetails.tabs.preferences'),
      component: <OrderPreferencesWrapper />,
    },
    {
      label: 'Candidates',
      component: <OrderCandidateMatchWrapper brands={preLoadedBrands} />,
    },
    {
      label: t('order.orderDetails.tabs.detailreport'),
      component: <OrderDetailReportWrapper orderReportDetails={selectOrderUiDetails?.orderReportDetails} />,
    },
    {
      label: t('order.orderDetails.tabs.bonus'),
      component: <OrderBonusWrapper />,
    },
  ];
  const loadingTabs = [
    {
      label: t('order.orderDetails.tabs.summary'),
      component: (
        <Grid container xs={12} spacing={2} margin={'0px'}>
          <Grid xs={4} paddingRight={'12px'}>
            {(featureFlagOrderMarginTool.enabled && featureFlagOrderMarginToolUI.enabled) && (
              <Grid direction={'column'}>
                <WrapperComponent
                  title={t('order.orderDetails.weeklyGrossPay.title')}
                  children={<Skeleton variant="rectangular" width="100%" height={600} />}
                />
              </Grid>
            )}
            <Grid direction={'column'}>
              <WrapperComponent
                title={t('order.createUnit.qualifications.title')}
                children={<Skeleton variant="rectangular" width="100%" height={600} />}
              />
            </Grid>
            <WrapperComponent
              title={t('order.newOrderCreation.tabs.orderRequirements')}
              children={<Skeleton variant="rectangular" width="100%" height={400} />}
            />
          </Grid>
          <Grid xs={8}>
            <WrapperForExperience
              title={t('facility.units.experience.title')}
              children={<Skeleton variant="rectangular" width="100%" height="100%" sx={{ minHeight: 200 }} />}
            />
            <WrapperComponentWithSubSections
              title={t('order.newOrderCreation.tabs.orderDetails')}
              childrenOne={<Skeleton variant="rectangular" width="100%" height="100%" sx={{ minHeight: 200 }} />}
              childrenTwo={<Skeleton variant="rectangular" width="100%" height="100%" sx={{ minHeight: 200 }} />}
            />
            <WrapperComponentWithSubSections
              title={t('placement.profile.tabs.additionalRequirements')}
              childrenOne={<Skeleton variant="rectangular" width="100%" height="100%" sx={{ minHeight: 200 }} />}
              childrenTwo={<Skeleton variant="rectangular" width="100%" height="100%" sx={{ minHeight: 200 }} />}
            />
          </Grid>
        </Grid>
      ),
    },
    {
      label: t('order.orderDetails.tabs.placements'),
      component: <OrderPlacementsWrapper />,
    },
    {
      label: t('order.orderDetails.tabs.preferences'),
      component: <OrderPreferencesWrapper />,
    },
    {
      label: 'Candidates',
      component: <OrderCandidateMatchWrapper brands={preLoadedBrands} />,
    },
    {
      label: t('order.orderDetails.tabs.detailreport'),
      component: <OrderDetailReportWrapper orderReportDetails={selectOrderUiDetails?.orderReportDetails} />,
    },
    {
      label: t('order.orderDetails.tabs.bonus'),
      component: <OrderBonusWrapper />,
    },
  ];
  //If Margintool is enabled, add change history tab
  //US-450779 - change history tracks magin tool changes
  if ((featureFlagOrderMarginTool.enabled && featureFlagOrderMarginToolUI.enabled)) {
    if (
      featureFlagOrderMarginTool.enabled &&
      featureFlagOrderMarginToolUI.enabled
    ) {
      tabs.push({
        label: t('order.payPackagesTab.title'),
        component: <PayPackagesWrapper />,
      });
    }
    tabs.push({
      label: t('order.orderDetails.tabs.changeHistory'),
      component: <OrderChangeHistoryWrapper />,
    });
    loadingTabs.push({
      label: t('order.orderDetails.tabs.changeHistory'),
      component: <Skeleton variant="rectangular" width="100%" height="100%" sx={{ minHeight: 200 }} />,
    });
  }

  useEffect(() => {
    setStickChoosen(taskStickChosen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskStickChosen]);

  useEffect(() => {
    dispatch(taskDetailsActions.setCurrentContainer(TaskEntity.ORDERS));
    setEntityStickChoosen(TaskEntity.ORDERS, dispatch);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tab = parseInt(queryString.parse(location.search).tab);
    const isTabSelectionValid = tab !== null && tab !== undefined && !isNaN(tab) && tab >= 0;
    dispatch(orderDataActions.setTabValue(isTabSelectionValid ? tab : 0));
  }, []);

  React.useEffect(() => {
    const refreshStatusData = getSessionValue(SessionKey.createPlacementMFS, StorageType.sessionStorage);
    if (
      refreshStatusData &&
      refreshStatusData.orderId > 0 &&
      refreshStatusData.candidateId > 0 &&
      refreshStatusData.brandId > 0
    ) {
      setCandidateIdR(refreshStatusData.candidateId);
      setBrandIdR(refreshStatusData.brandId);
      setOrderIdR(refreshStatusData.orderId);
      setOpenCreatePlacementFormX(true);
    }
  }, []);

  const handleClickUp = () => {
    const nextIdx = navigationProfiles[currentIndex - 1];
    const nextOrderId = nextIdx?.orderId;
    const currentTab = queryString.parse(location.search).tab || '0';
    history(`/order/${nextOrderId}?tab=${currentTab}`, {
      state: 'navigationCycle',
    });
    dispatch(navigationProfilesAction.setCurrentRowId({ rowId: navigationProfiles[currentIndex - 1]?.id }));
  };

  const handleClickDown = () => {
    const nextIdx = navigationProfiles[currentIndex + 1];
    const nextOrderId = nextIdx?.orderId;
    const currentTab = queryString.parse(location.search).tab || '0';
    history(`/order/${nextOrderId}?tab=${currentTab}`, {
      state: 'navigationCycle',
    });
    dispatch(navigationProfilesAction.setCurrentRowId({ rowId: navigationProfiles[currentIndex + 1]?.id }));
  };

  //handling custom tab change based on preference tab data changes::
  const customTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (preferenceChanged || orderPayPackagesGridIsDirty) {
      dispatch(orderDataActions.setConfirmationDialog({ open: true, tab: newValue }));
    } else {
      history(`${location.pathname}?tab=${newValue}`, { state: location?.state });
      dispatch(orderDataActions.setTabValue(newValue));
    }
  };

  const { drawerData } = useSelector(selectSearchResults);

  return (
    <>
      {promiseInProgress || inProgress || isUpdating ? (
        <DetailsPage
          title={`Order Details`}
          enablePageActionSpace
          head={<OrderDetailHeader fetchingOrderDetails={inProgress} />}
          statTiles={<Skeleton variant="rounded" height={40} />}
        >
          <GenericTabs
            tabs={loadingTabs}
            modifyUrl
            customHandleChange={customTabChange}
            addOnComponent={<MoreSideGlance />}
            analytics={{ name: 'Order Details' }}
          />
        </DetailsPage>
      ) : (
        <>
          {!promiseInProgress && !inProgress && !selectOrderUiDetails && (
            <CommonNoDataPage message={`Unable to find information about selected order`} />
          )}
          {!promiseInProgress &&
            !inProgress &&
            selectOrderUiDetails &&
            selectOrderUiDetails.currentStep === 'ViewOrderDetails' && (
              <>
                <DetailsPage
                  title={`Order Details`}
                  enablePageActionSpace
                  head={<OrderDetailHeader fetchingOrderDetails={inProgress} />}
                  statTiles={
                    <OrderQuickGlance quickGlanceDetails={selectOrderUiDetails.quickGlanceDetails} onClick={() => {}} />
                  }
                  titleActions={
                    <OrderHeaderWrapper
                      stickIconArray={[4]}
                      taskStickChosen={stickChoosen}
                      setOpenCreatePlacementForm={setOpenCreatePlacementForm}
                      setLastVerifiedUpdateStatus={setLastVerifiedUpdateStatus}
                      id={props?.id}
                      editStarted={selectOrderUiDetails?.isEditStarted}
                    />
                  }
                  navigationActions={
                    navigationProfiles?.length > 0 && (navigationFlag || location?.state === 'navigationCycle') ? (
                      <NavigationProfileCycle
                        handleClickUp={handleClickUp}
                        handleClickDown={handleClickDown}
                        disabledUp={upDisabled}
                        disabledDown={downDisabled}
                      />
                    ) : null
                  }
                  currentContainer={TaskEntity.ORDERS}
                  taskStickChosen={stickChoosen}
                >
                  {openCreatePlacementForm && (
                    <CreatePlacementWrapper
                      isDefaultOrder
                      open
                      handleClose={() => setOpenCreatePlacementForm(false)}
                      initialArgs={{ orderId: parseInt(props.id) }}
                    />
                  )}
                  {openCreatePlacementFormX && candidateIdR > 0 && brandIdR > 0 && orderIdR > 0 && (
                    <CreatePlacementWrapper
                      isDefaultOrder={true}
                      isDefaultCandidate={true}
                      isOrderRefreshRequest={false}
                      isCandidateRefreshRequest={true}
                      open
                      handleClose={() => setOpenCreatePlacementFormX(false)}
                      initialArgs={{ orderId: orderIdR, candidateId: candidateIdR, brandId: brandIdR }}
                      sessionKey={SessionKey.createPlacementMFS}
                    />
                  )}
                  {navigationData && navigationData.breadcrumbHierarchy && <BreadcrumbNavigation {...navigationData} />}
                  <GenericTabs
                    tabs={tabs}
                    modifyUrl
                    customHandleChange={customTabChange}
                    addOnComponent={<MoreSideGlance />}
                    analytics={{ name: 'Order Details' }}
                  />
                </DetailsPage>
              </>
            )}
          {!promiseInProgress &&
            !inProgress &&
            selectOrderUiDetails &&
            ['editRateCard'].includes(selectOrderUiDetails.currentStep) && (
              <>
                {showMandetryCss && (
                  <Grid item xs={12}>
                    <Alert
                      severity="info"
                      className={classes.customAlert}
                      classes={{
                        message: classes.alertMessage,
                        standardInfo: classes.alertColor,
                        icon: classes.alertIcon,
                      }}
                    >
                      {t('order.createUnit.warringMessage')}
                    </Alert>
                  </Grid>
                )}
                <DetailsPage
                  title={`Order Details`}
                  head={
                    <OrderHeader
                      headerDetails={selectOrderUiDetails.headerDetails}
                      handleOrderPropertyUpdate={() => {}}
                    />
                  }
                >
                  {selectOrderUiDetails.currentStep === 'editRateCard' && (
                    <RateCard
                      facilityId={selectOrderUiDetails.facilityId}
                      shifts={(selectOrderUiDetails.orderDetails.shifts ?? []).map(x => x.description)}
                      skillsets={selectOrderUiDetails.orderDetails.skillsets ?? []}
                      orderId={Number.parseInt(props.id)}
                      isBeingEdited
                    />
                  )}
                </DetailsPage>
              </>
            )}
          {!promiseInProgress && !inProgress && selectOrderUiDetails && tabValue !== 2 && disablePayPackageTab() && (
            <>
              <Grid item>
                <OrderDetailsButtonWrapper
                  openClearChangesConfirmation={openClearChangesConfirmation}
                  blockNavigation={blockNavigation}
                  modalOpen={modalOpen}
                  disableOptions={!selectOrderUiDetails.isEditStarted}
                  handleClearChanges={handleClearChanges}
                  handleSaveOrder={handleSaveOrder}
                  handleClearChangesConfirmClose={handleClearChangesConfirmClose}
                />
              </Grid>
            </>
          )}
          {!promiseInProgress &&
            !inProgress &&
            selectOrderUiDetails &&
            selectOrderUiDetails.currentStep === 'ViewOrderDetails' &&
            drawerOpen && (
              <OrderSidePanel
                open={drawerOpen}
                closeDrawer={() => {
                  setDrawerOpen(false);
                }}
                atAGlanceDetails={selectOrderUiDetails.atAGlance}
                updateLastVerified={handleLastVerified}
                lastVerifiedUpdateStatus={lastVerifiedUpdateStatus}
                handleOrderUpdate={handleOrderPropertyUpdate}
                positionsAvailable={selectOrderUiDetails.orderDetails.positionsAvailable}
                positionsConstant={selectOrderUiDetails.orderDetailsOrginal.positionsAvailable}
                editedOrder={selectOrderUiDetails.orderDetails}
                disableEdit={false}
                // @ts-ignore
                enableEditHSG={enableEditHSG}
              />
            )}
          {
            <DrawerFitted
              onDrawerClose={() => {
                dispatch(globalSearchActions.setDrawerData({ open: false, data: undefined }));
              }}
              width={450}
              top={0}
              // backgroundColor={theme.palette.framework.system.whisper}
              open={drawerData?.open ?? false}
              // shadow={category === 'candidate'}
            >
              {drawerData?.open && drawerData?.data ? (
                <SearchDrawerContent category={'placement'} data={drawerData?.data} />
              ) : null}
            </DrawerFitted>
          }
        </>
      )}
    </>
  );
};
